export default __webpack_public_path__ + "static/bg-sobre-1562062b3278a93e6e0f4302c80c1d38.png";